// Palette d'Horizon — source unique : src/lib/palette.json (décisions de Mélilia du 29/09, lot 7).
//
//   marine    texte, structure, actions principales, « en cours »
//   bleu      l'acquis : validé, terminé, payé, encaissé, publié, résolu, envoyé
//   bordeaux  accent de marque (titres de section, boutons secondaires) — jamais un statut
//   rouge     échec : retard, blocage, correction demandée, suppression
//   ambre     en attente (du client, de l'agence, de paiement) ; ambre-vif : étoiles des évaluations
//   sable…    surfaces ; muet : icônes estompées ; gris-texte : à venir, brouillon, annulé, en pause
//
// Les classes Tailwind (`text-marine`, `bg-sable`, `border-bordeaux/40`…) et les variables CSS
// (`var(--marine)`) portent les mêmes valeurs. Ce fichier sert aux couleurs écrites en JavaScript
// (graphiques, icônes colorées par `style`). Ne jamais réintroduire un hex en dur : ajouter un jeton.
import palette from "./palette.json";

export const COLORS = palette;
export default COLORS;
